import React from "react";
import styles from "./Style.module.css";

const MapLegend = () => {
  return (
    <div className={styles.legend}>
      <div className={styles.legendColor}></div>
      <span className={styles.legendLabel}>Inactive States</span>
    </div>
  );
};

export default MapLegend;
